import {lazy} from 'react';

import {Route} from 'react-router-dom';

export const MbHostLayout = lazy(() => import('../pages/mobile-client/layouts/MbHostLandingPageWrapper'));
export const Appts = lazy(() => import('../pages/mobile-client/Appts'));
export const ApptId = lazy(() => import('../pages/mobile-client/ApptDetails'));
export const Events = lazy(() => import('../pages/mobile-client/Events'));

export const ClientMobileRoutes = (
  <>
    <Route element={<MbHostLayout />}>
      <Route path="appts" element={<Appts />}>
        <Route path=":apptId" element={<ApptId />} />
      </Route>
      <Route path="events" element={<Events />}>
      </Route>
    </Route>
  </>
);
